<ng-container
  [ngTemplateOutlet]="
    !category?.parents?.length && category?.id !== topMenuPromotionLinkId
      ? fatherCategory
      : !category?.parents?.length && category?.id === topMenuPromotionLinkId
      ? storyblokFatherCategory
      : nestedCategory
  "
></ng-container>

<ng-template #fatherCategory>
  <a
    [attr.data-category-id]="category?.id"
    [mmTestTarget]="'selected-category-link'"
    [mmTestState]="isActive ? 'active' : 'inactive'"
    (click)="onCategorySelected($event, category)"
    class="category-item"
    [ngClass]="{
      'category-item--active': isActive,
      'top-categories-navbar__item__angebote': category?.id === promoCategoryId
    }"
    fxLayoutAlign="flex-start center"
  >
    <mm-icon *ngIf="iconName" class="category-item__icon" [name]="iconName"> </mm-icon>
    {{ category?.name }}
    <mm-icon *ngIf="category?.id != blackDealsCategoryId" name="chevron-right" class="category-item__arrow">
    </mm-icon>
  </a>
</ng-template>
<ng-template #storyblokFatherCategory>
  <a
    [mmTestTarget]="'selected-category-link'"
    [mmTestState]="isActive ? 'active' : 'inactive'"
    [appStoryblokEditable]="category.storyBlokEditable"
    [ngClass]="{ 'category-item--active': isActive }"
    class="category-item"
    fxLayoutAlign="flex-start center"
  >
    <mm-icon *ngIf="iconName" class="category-item__icon" [name]="iconName"> </mm-icon>
    <span (click)="onCategorySelected($event, category)" appDisableClickEvent>
      {{ category?.name }}
    </span>
  </a>
</ng-template>
<ng-template #nestedCategory>
  <a
    [mmTestTarget]="'selected-category-link'"
    [mmTestState]="isActive ? 'active' : 'inactive'"
    (click)="onCategorySelected($event, category)"
    [ngClass]="{ 'category-item--active': isActive }"
    class="category-item category-item--nested"
    fxLayoutAlign="flex-start center"
  >
    <mm-icon *ngIf="iconName" class="category-item__icon" [name]="iconName"> </mm-icon>
    {{ category?.name }}
  </a>
</ng-template>
